import React, { useState,useEffect } from 'react';
import {Paper,Stepper,Step,StepLabel,Typography,CircularProgress,Divider,Button} from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import {commerce} from '../../../lib/commerce';
import useStyles from './styles';
import AddressForm from '../AddressForm';
import PaymentForm  from '../PaymentForm';



const steps=['Shipping address','Payment details'];
const Checkout=({cart,order,onCaptureCheckout,error})=> {
     const[activeStep,setActiveStep]=useState(0);
     const[carti,setCart]=useState({});
     const[checkoutToken,setCheckoutToken]=useState(null);
     const [shippingData,setShippingData]= useState({});
     const classes=useStyles();
      useEffect(()=>{
        const generateToken= async ()=> {
     try 
     {
        const token= await  commerce.checkout.generateToken(cart.id,{type:'cart'});
        console.log(token);
        setCheckoutToken(token);
     } catch(error){
    
     }
    }
     generateToken();

      },[cart] );

      const nextStep=() =>setActiveStep((prevActiveStep)=> prevActiveStep+1);
      const backStep=() =>setActiveStep((prevActiveStep)=> prevActiveStep-1);
      const handleEmptyCart=async() =>{
        setCart(await commerce.carti.empty());
       
      }
      const next=(data) => {
      setShippingData(data);
      nextStep();
      }
      const Confirmation =() =>(
           
            <div>
               <h2> Thanx for Purchase </h2>
                 <br/>
                 <br/>
                 
                 <Button component={Link} variant="outlined" type="button" color="primary" to="/" >Back to home</Button>
           </div>
      );
      const Form=()=>  activeStep===0
      ?<AddressForm  checkoutToken={checkoutToken} next={next}/> :
      <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} onCaptureCheckout={onCaptureCheckout}/>
         return (
        <>
        <div className={classes.toolbar} />
        <main  className={classes.layout}>
            <Paper className={classes.paper}>
                <Typography variant="h4" align="center"> Checkout</Typography>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map((step)=> (
                     <Step key={step}>
                        <StepLabel>{step}</StepLabel>
                     </Step>
                ) )}
                </Stepper>
                {activeStep===steps.length?<Confirmation />: checkoutToken &&<Form/>}

            </Paper>

        </main>
        </>
    )
}
export default Checkout;